import { useEffect, useState } from "react";
import api from "../utils/axios";

const useTotalMarks = () => {
	const [totalMarks, setTotalMarks] = useState(0);
	const [totalAddresses, setTotalAddresses] = useState(0);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const marksResponse = await api.get('/total-marks');
				const { totalPoints, totalAddresses } = marksResponse.data;
				setTotalMarks(totalPoints);
				setTotalAddresses(totalAddresses);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};


		fetchData(); // Initial fetch
		const intervalId = setInterval(fetchData, 60000); // Update interval to 3 seconds

		return () => {
			clearInterval(intervalId);
		};

	}, []);

	return {
		totalMarks,
		totalAddresses,
	};
};

export default useTotalMarks;
